/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.groups.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.view.application.groups.createModal.controllers',
  'acme.view.application.groups.removeModal.controllers',
  'acme.common.factory.gridState'
])

.controller('GroupsListController', ['$scope', '$state', '$uibModal', '$timeout', 'ApiService', 'PermissionsService', 'NoticeFactory', 'GridStateFactory', function($scope, $state, $uibModal, $timeout, ApiService, PermissionsService, NoticeFactory, GridStateFactory) {

    $scope.groupsList = {

      model: [],
      addModal: {},
      isLoaded: false,

      notice: new NoticeFactory(),

      gridState: new GridStateFactory(),

      grid: {
        pageSize: 50,
        showFooter: true,
        paginate: true,
        multiselect: false,
        enableRowSelection: false,
        useExternalPagination: true,
        useExternalSorting: true,
        columns: [
          {
            field: 'name',
            displayName: 'Name'
          },
          {
            field: 'displayName',
            displayName: 'Display Name'
          }
        ]
      },
      
      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Manage Groups',
          buttonRight: {
            label: 'Create',
            permissions: 'USER_GROUPS_CREATE',
            action: function() {
              $scope.groupsList.create();
            }
          }
        });

        if (PermissionsService.check('USER_GROUPS_DELETE')) {
          this.grid.columns.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.groupsList.remove(row.entity.id);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only"> - Opens Dialog</span></a></div>'
          });
        }

        if (PermissionsService.check('USER_GROUPS_UPDATE')) {
          this.grid.columns.unshift({
            field: 'roles',
            displayName: 'Roles',
            onCellNavClick: function(row, col) {
              $scope.groupsList.gridDoubleClick(row);
            },
            enableSorting: false,
            enableHiding: false,
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onGridDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.displayName || row.entity.name }}</span></a></div>'
          });
        }

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getGroups();

      },

      getGroups: function() {
        ApiService.groups.list(this.gridState.getGridState()).then(this.success.init, this.error.init);
      },

      findGroup: function(id) {

        var i, ii,
          r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].id === id) {
            r = {
              group: this.model[i],
              index: i
            };
          }
        }

        return r;

      },

      create: function(response) {

        var self = $scope.groupsList;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/groups/modals/createGroup.tpl.html',
          size: 'lg',
          controller: 'GroupsCreateModalController',
          resolve: {
            groups: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (group) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          ApiService.groups.create(group).then(self.success.create, self.error.create);
        }, function () {
          // Do nothing
        });

      },

      remove: function(id) {
        var self = $scope.groupsList,
          found = self.findGroup(id);

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/groups/modals/removeGroup.tpl.html',
          size: 'md',
          controller: 'GroupsRemoveModalController',
          resolve: {
            currentGroup: function() {
              return found.group;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.removeModal.result.then(function () {
          ApiService.groups.remove(found.group.id).then(function(response, status, headers, config) {
            self.model.splice(found.index, 1);
            self.success.remove(response, status, headers, config);
          }, function(response, status, headers, config) {
            self.error.remove(response, status, headers, config);
          });
        }, function () {
          // Do nothing
        });
      },

      success: {
        init: function(response) {
          var self = $scope.groupsList;
          //next tick
          $timeout(function() {
            self.model = response.data.payload.list;
            self.gridState.setPropertyValue('totalItems', response.data.payload.pagination.count);
          }, 0);
          self.isLoaded = true;
        },
        create: function(response) {
          var self = $scope.groupsList;
          self.model.push(response.data.payload);
        },
        remove: function(response) {}
      },

      error: {
        init: function(response) {},
        create: function(response) {
          var self = $scope.groupsList;
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);

          $timeout(function() {
            self.notice.hideErrorMessages();
          }, 3000);
        },
        remove: function(response) {
          var self = $scope.groupsList;
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);
          $timeout(function() {
            self.notice.hideErrorMessages();
          }, 3000);
        }
      },

      gridDoubleClick: function(row) {
        if (PermissionsService.check('USER_GROUPS_UPDATE')) {
          $state.go('application.groups.roles', { id: row.entity.id });
        }
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.groupsList;
        self.gridState.updateGridState(newPage, pageSize);
        self.getGroups();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.groupsList, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getGroups();
        }
      }

    };

    $scope.groupsList.init();

}]);